import "whatwg-fetch"
import { Category } from "../types/category"
import { Region } from "../types/area"
import { StorageHandler, StorageKeys } from "./storage_handler"
import Sentry from "../Common/Sentry"
import { Categories } from "./category"

const AREAS_PATH = "/areas"
const CATEGORIES_PATH = "/categories"
const PLACE_COUNTS_PATH = "/place_counts"

export class FilterConditionsHandler {
  constructor() {}

  async fetchAreas() {
    // TODO: Fetch from localStorage
    const res = await this.request(AREAS_PATH)
    // TODO: Error handling
    if (res.status != 200) {
      return
    }
    // TODO: Store to localStorage
    return res.body
  }

  async fetchCategories() {
    // TODO: Fetch from localStorage
    const res = await this.request(CATEGORIES_PATH)
    // TODO: Error handling
    if (res.status != 200) {
      return
    }
    // TODO: Store to localStorage
    return res.body
  }

  async fetchPlaceCounts(params: object) {
    const query = Object.keys(params)
      .filter((key) => params[key] != null)
      .map((key) => `${key}=${params[key]}`)
      .join("&")
    const res = await this.request(`${PLACE_COUNTS_PATH}?${query}`)
    return res.body
  }

  async request(path: string) {
    const response = await fetch(path, {
      headers: { "Contnet-Type": "application/json; charset=utf-8" },
    })
    const json = await response.json()
    return {
      status: response.status,
      body: json,
    }
  }
}

interface setValuesType {
  setCategory: Function
  setPrefecture: Function
  setCity: Function
  setLocationText: Function
  locations: Array<Region>
  categories: Array<Category>
}
export class FilterConditionsStorage {
  static setCachedValuesAsDefault(args: setValuesType) {
    if (args.categories.length == 0 || args.locations.length == 0) {
      return
    }
    try {
      const storageHandler = new StorageHandler()
      const categoryId = storageHandler.get(StorageKeys.categoryIdKey)
      const cityId = parseInt(storageHandler.get(StorageKeys.cityIdKey))
      const prefectureId = parseInt(
        storageHandler.get(StorageKeys.prefectureIdKey)
      )
      if (categoryId) {
        const category = Categories.find(parseInt(categoryId), args.categories)
        if (category) {
          args.setCategory(category)
        }
      }
      if (cityId || prefectureId) {
        args.locations.forEach((region) => {
          region.prefectures.forEach((pref) => {
            if (pref.id == prefectureId) {
              args.setPrefecture(pref)
              args.setLocationText(pref.name)
            }
            const city = pref.cities.find((city) => city.id == cityId)
            if (city) {
              args.setCity(city)
              args.setLocationText(city.name)
            }
          })
        })
      }
    } catch (e) {
      Sentry.captureException(e)
    }
  }

  static setCacheValues(
    categoryId: string,
    cityId: string,
    prefectureId: string
  ) {
    try {
      const storageHandler = new StorageHandler()
      if (categoryId) {
        storageHandler.set(StorageKeys.categoryIdKey, categoryId)
      }
      if (cityId) {
        storageHandler.set(StorageKeys.cityIdKey, cityId)
      }
      if (prefectureId) {
        storageHandler.set(StorageKeys.prefectureIdKey, prefectureId)
      }
    } catch (e) {
      Sentry.captureException(e)
    }
  }
}
